import Cookies from 'js-cookie';

const TOKEN_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  ID_TOKEN: 'idToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_EMAIL: 'userEmail',
  ROLE: 'role',
} as const;

const COOKIE_OPTIONS = {
  expires: 7, // 7 days
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict' as const,
};

export interface StoredTokens {
  accessToken?: string;
  idToken?: string;
  refreshToken?: string;
  userEmail?: string;
  role?: string;
}

export const tokenPersistence = {
  saveTokens: (tokens: StoredTokens): void => {
    if (tokens.accessToken) {
      Cookies.set(TOKEN_KEYS.ACCESS_TOKEN, tokens.accessToken, COOKIE_OPTIONS);
    }
    if (tokens.idToken) {
      Cookies.set(TOKEN_KEYS.ID_TOKEN, tokens.idToken, COOKIE_OPTIONS);
    }
    if (tokens.refreshToken) {
      Cookies.set(TOKEN_KEYS.REFRESH_TOKEN, tokens.refreshToken, COOKIE_OPTIONS);
    }
    if (tokens.userEmail) {
      Cookies.set(TOKEN_KEYS.USER_EMAIL, tokens.userEmail, COOKIE_OPTIONS);
    }
    if (tokens.role) {
      Cookies.set(TOKEN_KEYS.ROLE, tokens.role, COOKIE_OPTIONS);
    }
  },

  loadTokens: (): StoredTokens => {
    return {
      accessToken: Cookies.get(TOKEN_KEYS.ACCESS_TOKEN),
      idToken: Cookies.get(TOKEN_KEYS.ID_TOKEN),
      refreshToken: Cookies.get(TOKEN_KEYS.REFRESH_TOKEN),
      userEmail: Cookies.get(TOKEN_KEYS.USER_EMAIL),
      role: Cookies.get(TOKEN_KEYS.ROLE),
    };
  },

  clearTokens: (): void => {
    Cookies.remove(TOKEN_KEYS.ACCESS_TOKEN);
    Cookies.remove(TOKEN_KEYS.ID_TOKEN);
    Cookies.remove(TOKEN_KEYS.REFRESH_TOKEN);
    Cookies.remove(TOKEN_KEYS.USER_EMAIL);
    Cookies.remove(TOKEN_KEYS.ROLE);
  },

  hasValidTokens: (): boolean => {
    const tokens = tokenPersistence.loadTokens();
    return !!(tokens.accessToken && tokens.userEmail);
  },
};
